/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import ListCurrentThreatsTable from "./ListCurrentThreatsTable";

export default ListCurrentThreatsTable;
